import React from "react";
import PanelExtended, {PanelHeader} from "../Common/Components/PanelExtended";
import SubleagueChatMessages from "./SubleagueChatMessages";
import {FormattedMessage} from "react-intl";

class Chat extends React.PureComponent {

    constructor(props) {
        super(props);

        this.handleRefresh = this.handleRefresh.bind(this);
    }

    render() {
        let {chat: {show, messages}} = this.props;

        if (!show) {
            return null;
        }

        return <PanelExtended>
            <PanelHeader title="Chat">
                <button className="btn btn-default" onClick={this.handleRefresh}>
                    <FormattedMessage id="chat.refresh"/>
                </button>
            </PanelHeader>
            <MessageInput onSubmit={message => this.props.onSendMessage(message)}/>
            <SubleagueChatMessages messages={messages}/>
        </PanelExtended>
    }

    componentWillMount() {
        this.props.load(this.props.subleagueId);
    }

    handleRefresh() {
        this.props.load(this.props.subleagueId);
    }
}

class MessageInput extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {message: ''};

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
    }

    handleOnChange(e) {
        this.setState({message: e.target.value});
    }

    handleSubmit(e) {
        e.preventDefault();
        this.props.onSubmit(this.state.message);
        this.setState({message: ''});
    }

    render() {
        return <form onSubmit={this.handleSubmit}>
            <FormattedMessage id="chat.placeholder">
                {message =>
                    <input
                        placeholder={message}
                        className="search-form__input"
                        onChange={this.handleOnChange}
                        type="text"
                        value={this.state.message}/>
                }
            </FormattedMessage>
        </form>
    }
}

export default Chat